import { render, staticRenderFns } from "./AddOrEditSetModal.vue?vue&type=template&id=0a8bd86a&"
import script from "./AddOrEditSetModal.vue?vue&type=script&lang=js&"
export * from "./AddOrEditSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports